export enum CharacterType {
    Luna = "luna",
    Andy = "andy",
    Carmen = "carmen",
    Leo = "leo",
}
